// "Live on Student Desk" means students have exactly what the editor shows.
// Any content or reference edit after publishing takes the badge away until
// the teacher sends it again with Update Student Desk. (Renames don't: the
// server copies a new title to students as soon as it's saved.)

export const NO_CHANGES_TO_UPDATE = 'No changes to update — your students already have the latest version.';

/** The lesson content students get on Update, as one comparable string. */
export function contentSignature(draft) {
  return JSON.stringify([draft?.framework || null, draft?.references || []]);
}

/**
 * @param draft            the editor's draft (`has_unpublished_changes` comes
 *                         from the server: edits saved before this page opened)
 * @param signature        contentSignature(draft) now
 * @param syncedSignature  contentSignature at load / last publish
 */
export function isLiveOnStudentDesk(draft, signature, syncedSignature) {
  return draft?.status === 'published' && !draft.has_unpublished_changes && signature === syncedSignature;
}
